import { writable } from "svelte/store";

localStorage.modal = JSON.stringify({
    test: 'closed',
})

export const modal = writable(JSON.parse(localStorage.modal));

modal.subscribe(value => {
    localStorage.modal = JSON.stringify(value)
});